export const getYearsList = (upto = 50) => {
  const currentYears = new Date().getFullYear();
  const yearsList = [];
  for (let i = 0; i <= upto; i++) {
    yearsList.push({
      id: i,
      text: `${currentYears - i}`,
    });
  }

  return yearsList;
};
